import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';

import { createPower, updatePower } from '../../app/store/actions/power';
import FIELDS from '../../data/fields';
import { history } from '../../routers/AppRouter';
import ROUTES from '../../data/routes';

class PowerForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      powerRangeId: this.props.back.location.selectedRange && this.props.back.location.selectedRange.id,
      id: null,
      toEdit: false,
      isLoading: false,
      messageError: '',
      messageSuccess: '',
      kw: '',
      hp: '',
    };
  }

  componentDidMount = async () => {
    if (this.props.back.location.selected) {
      await this.setSelected(this.props.back.location.selected);
    }
  }

  setSelected = async (selected) => {
    this.setState({
      toEdit: true,
      id: selected.id,
      kw: parseFloat(selected.kw),
      hp: parseFloat(selected.hp),
    });
  }

  setValue = (att, value) => {
    this.setState({ [att]: value });
  }

  handleBlur = (att, value) => {
    if (att === 'kw') {
      const { start, end } = this.props.back.location.selectedRange;
      if (parseFloat(value) >= parseFloat(start) && parseFloat(value) <= parseFloat(end)) {
        this.setState({ [att]: value });
      } else if (parseFloat(value) < parseFloat(start)) {
        this.setState({ kw: parseFloat(start) });
      } else if (parseFloat(value) > parseFloat(end)) {
        this.setState({ kw: parseFloat(end) });
      } else {
        this.setState({ kw: '' });
      }
    }
  }

  goBack = () => {
    history.push({
      pathname: ROUTES.POWER,
      selected: this.props.back.location.selectedRange
    })
  };

  create = async () => {
    const { powerRangeId, kw, hp } = this.state;
    if (!kw || !hp) {
      this.setState({ messageError: I18n.t('fieldsNotReported') });
    } else {
      this.setState({ isLoading: true });
      try {
        const power = `${kw}kW - ${hp}HP`;
        await this.props.createPower({ powerRangeId, power, kw, hp });
        await this.setState({ messageSuccess: I18n.t('registrationPerformed') });
        await this.goBack();
      } catch (err) {
        const error = err.response && err.response.data && err.response.data.error
        this.setState({ messageSuccess: '' })
        if (error && error.message) {
          const messageError = (error.code && error.details) ?
            `${error.code} - ${error.details} | ${error.message}`
            : error.message;

          this.setState({ messageError: messageError })
        } else {
          this.setState({ messageError: I18n.t('errorOcurred') })
        }
      }
      this.setState({ isLoading: false });
    }
  }

  update = async () => {
    const { id, kw, hp, powerRangeId } = this.state;
    if (!id || !kw || !hp) {
      this.setState({ messageError: I18n.t('fieldsNotReported') });
    } else {
      this.setState({ isLoading: true });
      try {
        const power = `${kw}kW - ${hp}HP`;
        await this.props.updatePower({ powerRangeId, id, power, kw, hp });
        await this.setState({ messageSuccess: I18n.t('changeMade') });
        await this.goBack();
      } catch (err) {
        const error = err.response && err.response.data && err.response.data.error
        this.setState({ messageSuccess: '' })

        if (error && error.message) {
          const messageError = (error.code && error.details) ?
            `${error.code} - ${error.details} | ${error.message}`
            : error.message;

          this.setState({ messageError: messageError })
        } else {
          this.setState({ messageError: I18n.t('errorOcurred') })
        }
      }
      this.setState({ isLoading: false });
    }
  }

  render() {
    const {
      isLoading, messageSuccess, kw, hp, messageError, toEdit,
    } = this.state;

    return (
      <div className="form-main">
        <h2 className="header-form-client">
          {`${(toEdit) ? I18n.t('editar') : I18n.t('new')} ${I18n.t('power')}`}
        </h2>
        <form>
          <div className="form-group">
            <p className="margin-bottom-2">
              {I18n.t('kw')}
            </p>
            <input
              type="number"
              onChange={e => this.setValue('kw', e.target.value)}
              onBlur={e => this.handleBlur('kw', e.target.value)}
              value={this.state.kw}
              className="form-control"
              placeholder=""
              maxLength={FIELDS.max}
            />
          </div>

          <div className="form-group">
            <p className="margin-bottom-2">
              {I18n.t('hp')}
            </p>
            <input
              type="number"
              onChange={e => this.setValue('hp', e.target.value)}
              value={hp}
              className="form-control"
              placeholder=""
              maxLength={FIELDS.max}
            />
          </div>

          {!!messageSuccess && <p className="color-green margin-top-10">{messageSuccess}</p>}
          {!!messageError && <p className="color-red margin-top-10">{messageError}</p>}

          <div className="row margin-left-0 margin-top-10">
            <button
              type="button"
              onClick={() => this.goBack()}
              className="btn btn-warning margin-right-15"
            >
              {I18n.t('return')}
            </button>

            <button
              type="button"
              className="btn btn-dark"
              onClick={() => (!toEdit) ? this.create() : this.update()}
              disabled={isLoading}
            >
              {(!toEdit) ? I18n.t('toSend') : I18n.t('resend')}
            </button>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (/* state */) => ({});

const mapDispatchToProps = dispatch => ({
  createPower: (newPower) => dispatch(createPower(newPower)),
  updatePower: (updPower) => dispatch(updatePower(updPower)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PowerForm);
